import React, { FC } from "react";
import Box from "react-raster";
import styled from "styled-components";
import { Logo } from "../../assets/svg/logo";

const LoadingBar = styled.div`
  width: 9rem;
  height: 0.2rem;
  position: relative;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.1);
  margin-top: 2rem;

  ::before {
    content: "";
    width: 6rem;
    height: 0.2rem;
    background: #a6acaf;
    position: absolute;
    left: -34px;
    animation: progressbar 2s infinite ease;

    @keyframes progressbar {
      50% {
        left: 8rem;
      }
    }
  }
`;

export const PageLoader: FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      maxWidth="10rem"
    >
      <Logo width="12rem" />
      <LoadingBar />
    </Box>
  );
};
